import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKrispcallRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#8D34F0",
			d: "M2.3457 15.4539C2.3457 9.27515 2.3457 6.18571 4.26525 4.26623C6.18473 2.34668 9.2741 2.34668 15.4529 2.34668H16.5452C22.724 2.34668 25.8133 2.34668 27.7329 4.26623C29.6524 6.18571 29.6524 9.27515 29.6524 15.4539V16.5461C29.6524 22.725 29.6524 25.8144 27.7329 27.7339C25.8133 29.6533 22.724 29.6533 16.5452 29.6533H15.4529C9.2741 29.6533 6.18473 29.6533 4.26525 27.7339C2.3457 25.8144 2.3457 22.725 2.3457 16.5461V15.4539Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#krispcallRegularPaint0)",
			d: "M8.90123 29.6533L23.1007 29.6533C26.7202 29.6533 29.6543 26.7192 29.6543 23.0997L29.6543 8.90025C29.6543 5.2808 26.7202 2.34665 23.1007 2.34665L8.90123 2.34665C5.28178 2.34665 2.34763 5.2808 2.34763 8.90025L2.34763 23.0997C2.34763 26.7192 5.28178 29.6533 8.90123 29.6533Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#krispcallRegularPaint1)",
			d: "M29.6524 15.4539C29.6524 9.27515 29.6524 6.18571 27.7329 4.26623C25.8133 2.34668 22.724 2.34668 16.5452 2.34668H15.4529C9.2741 2.34668 6.18473 2.34668 4.26525 4.26623C2.3457 6.18571 2.3457 9.27515 2.3457 15.4539V16.5461C2.3457 22.725 2.3457 25.8144 4.26525 27.7339C6.18473 29.6533 9.2741 29.6533 15.4529 29.6533H16.5452C22.724 29.6533 25.8133 29.6533 27.7329 27.7339C29.6524 25.8144 29.6524 22.725 29.6524 16.5461V15.4539Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#krispcallRegularPaint2)",
			d: "M12.7274 24.9602C11.9743 25.5033 10.9012 25.3529 10.4061 24.5912C8.75493 22.0505 7.80859 19.0937 7.80859 15.9381C7.80859 12.8379 8.72195 9.92961 10.3198 7.41929C10.805 6.65682 11.8698 6.49495 12.6254 7.02812C12.7646 7.12628 12.9085 7.22822 13.0577 7.33381C13.5646 7.69273 13.6697 8.36483 13.3404 8.87514C12.0003 10.9515 11.2331 13.3642 11.2331 15.9381C11.2331 18.5339 12.0135 20.9657 13.3746 23.0539C13.728 23.5959 13.6237 24.3126 13.0878 24.6999C12.9642 24.7892 12.8441 24.876 12.7274 24.9602Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#krispcallRegularPaint3)",
			d: "M17.6008 10.5512C16.8057 9.98834 15.6598 10.1557 15.2197 10.9954C14.4336 12.4948 13.9941 14.1702 13.9941 15.9379C13.9941 17.7426 14.4522 19.451 15.2693 20.9742C15.718 21.8105 16.8663 21.9677 17.6558 21.3971L18.0095 21.1415C18.7381 20.6148 18.8911 19.6533 18.5451 18.8523C18.1548 17.9486 17.9407 16.9657 17.9407 15.9379C17.9407 14.9353 18.1445 13.9754 18.5168 13.0901C18.8552 12.2854 18.6926 11.3243 17.9577 10.804L17.6008 10.5512Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#krispcallRegularPaint4)",
			d: "M23.0233 14.3046C22.1904 13.6935 20.8995 14.0065 20.7143 14.985C20.6556 15.2948 20.625 15.6132 20.625 15.938C20.625 16.2772 20.6584 16.6093 20.7221 16.932C20.9157 17.9103 22.2116 18.2131 23.0391 17.5937C23.6705 17.1211 24.1953 16.5758 24.1918 15.9426C24.1882 15.3103 23.6585 14.7707 23.0233 14.3046Z"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "krispcallRegularPaint0",
				x1: 14.7722,
				x2: 13.6799,
				y1: 33.6128,
				y2: 17.6384,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#F4B7FF",
					stopOpacity: .7
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .495,
					stopColor: "#F4B7FF",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "krispcallRegularPaint1",
				x1: 7.39744,
				x2: 21.4604,
				y1: 2.34668,
				y2: 20.2325,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#F4B7FF",
					stopOpacity: .7
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .95,
					stopColor: "#F4B7FF",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "krispcallRegularPaint2",
				x1: 16.0006,
				x2: 16.0006,
				y1: 6.09328,
				y2: 25.9173,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#fff" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EFEFEF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "krispcallRegularPaint3",
				x1: 15.9991,
				x2: 15.9991,
				y1: 6.0931,
				y2: 25.9171,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#fff" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EFEFEF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "krispcallRegularPaint4",
				x1: 15.9998,
				x2: 15.9998,
				y1: 6.09322,
				y2: 25.9172,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#fff" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#EFEFEF"
				})]
			})
		] })
	]
});
export default SvgKrispcallRegularIcon;
